import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { routes } from "../constants/routes";
import { Routes } from "../constants";
import Swal from "sweetalert2";
import { injectModels } from "../redux/injectModels";
import { JWT } from "../Components/shared";

const Header = (props) => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState();
  const [job, setJob] = useState();
  const [image, setImage] = useState("");

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getUserProfile();
      if (res.user) {
        setUserName(res && res.user.username);
        setJob(res && res.user.job);
        setImage(res && res.user.profile_image);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleLogOut = () => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to Logout?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let email = localStorage.getItem("RememberMeEmail");
          let password = localStorage.getItem("Password");
          localStorage.clear();
          if (email != null && password != null) {
            localStorage.setItem("RememberMeEmail", email);
            localStorage.setItem("Password", password);
          }
          JWT.removeJWT();
          navigate("/");
          toast.success("Logged out successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
          toast.dismiss();
        } catch (err) {
          console.log(err);
          Swal.fire("FAQ!", "Something went wrong!", "error");
          return Promise.reject(err);
        }
      }
    });
  };

  const handleToggle = () => {
    const list = document.querySelector("body").classList;
    if (list.contains("toggle-sidebar")) {
      list.remove("toggle-sidebar");
    } else {
      list.add("toggle-sidebar");
    }
  };
  const handleProfile = (e) => {};

  return (
    <React.Fragment>
      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      >
        <div className="d-flex align-items-center justify-content-between">
          <Link
            to={routes.DASHBOARD}
            className="logo d-flex align-items-center"
          >
            <img src="/assets/img/logo.png" alt="" />
          </Link>
          <i
            className="bi bi-list toggle-sidebar-btn"
            onClick={handleToggle}
          ></i>
        </div>
        <div className="welcometxt ps-3">
          <p>Welcome to Focuskon!</p>
        </div>
        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            <li className="nav-item dropdown pe-3">
              <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center">
                  <li className="nav-item dropdown pe-3">
                    <a
                      className="nav-link nav-profile d-flex align-items-center pe-0"
                      href="#"
                      data-bs-toggle="dropdown"
                    >
                      <img
                        src={image}
                        alt="Profile"
                        className="rounded-circle"
                      />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                      <li className="dropdown-header">
                        <h6>{userName}</h6>
                        <span>{job}</span>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to={Routes.PROFILE}
                          onClick={handleProfile}
                        >
                          <i className="bi bi-person"></i>
                          <span>My Profile</span>
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="#"
                          onClick={handleLogOut}
                        >
                          <i className="bi bi-box-arrow-right" />
                          <span>Sign Out</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </li>
          </ul>
        </nav>
      </header>
    </React.Fragment>
  );
};
export default injectModels(["admin", "application"])(Header);
